




























































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { FilterItem } from '@core/interfaces/filter-item-interface';
import PaginationInterface from '@core/interfaces/pagination-interface';
import TableFooter from '@shared/components/tables/table-footer/table-footer.vue';
import TableMock from '@shared/components/mocks/table-mock/table-mock.vue';
import SendMessageUsingTemplateMixin from '@shared/components/tables/abstract-table/send-message-using-template-mixing';
import { v4 as uuidv4 } from 'uuid';

@Component({
  name: 'bpc-message-entity-table',
  components: {
    'bpc-field-wrapper': FieldWrapper,
    'bpc-table-footer': TableFooter,
    'bpc-table-mock': TableMock,
  },
})
export default class MessageEntityTable extends mixins(
  AbstractField,
  SendMessageUsingTemplateMixin,
) {
  @Prop({
    type: Boolean,
    default: true,
  })
  readonly showSendMessageButton: boolean;

  @Prop({
    type: [Object, Array],
    default() {
      return [];
    },
  })
  readonly filters: FilterItem[];

  // Data
  public messagesObservableSubscription = null;
  public fields = [
    {
      key: 'title',
      label: this.$t('global.messages_entity.title.label'),
      sortable: false,
      thClass: 'w-40',
    },
    {
      key: 'formatted_type',
      label: this.$t('global.messages.type.label'),
      sortable: false,
      thClass: 'w-10',
    },
    {
      key: 'receivers',
      label: this.$t('global.messages_entity.receivers.label'),
      sortable: false,
      thClass: 'w-20',
    },
    {
      key: 'date',
      label: this.$t('global.messages_entity.date.label'),
      sortable: false,
      thClass: 'w-15',
    },
    {
      key: 'send_mail',
      label: this.$t('global.messages_entity.send_mail.label'),
      sortable: false,
      thClass: 'w-15',
    },
    {
      key: 'actions',
      label: '',
      sortable: false,
      thClass: 'w-10',
    },
  ];
  public messages = [];
  public pagination: PaginationInterface = {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    from: 0,
    to: 0,
    total: 0,
  };
  public loading = false;
  public messageTitle = null;
  public messageBody = null;
  public showMessageModalId = uuidv4();

  // Computed
  get showNewMessageButton(): boolean {
    return (
      this.$authorizationService.hasPermissionForAction('messages', 'send') &&
      this.showSendMessageButton
    );
  }

  get relatedEntity() {
    return {
      id: this.relatedEntityId,
      contact_id: this.relatedContactId,
    };
  }

  get relatedEntityName(): string {
    const filter = this.filters.find(item => {
      return item?.filterField === 'related_entity_name';
    });
    return filter?.value;
  }

  get relatedContactId(): number {
    const filter = this.filters.find(item => {
      return item?.filterField === 'related_contact_id';
    });
    return filter?.value;
  }

  get relatedEntityId(): number {
    const filter = this.filters.find(item => {
      return item?.filterField === 'related_entity_id';
    });
    return filter?.value;
  }

  get relatedEntityType(): string {
    const filter = this.filters.find(item => {
      return item?.filterField === 'related_entity_type';
    });
    return filter?.value;
  }

  get otherContactRelatedMessages(): boolean {
    const filter = this.filters.find(item => {
      return item?.filterField === 'other_related_messages';
    });
    return filter?.value;
  }

  get currentPage() {
    return this.pagination.current_page;
  }

  // Lifecycle hooks
  mounted() {
    this.getMessagesFromRelatedEntity();
  }

  // Methods
  getMessagesFromRelatedEntity() {
    this.loading = true;
    const fetchEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('message')}`;
    const params = this.constructParamsToQuery();
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.get(fetchEntityPath, {
      params: params,
    });

    if (this.messagesObservableSubscription) {
      this.messagesObservableSubscription.unsubscribe();
    }

    this.messagesObservableSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.messages = res.data;

        if (res.meta) {
          this.pagination = res.meta;
        }

        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }

  constructParamsToQuery(): object {
    const params = {
      page: this.pagination.current_page,
      per_page: this.pagination.per_page,
      orderBy: 'created_at',
      orderDirection: 'desc',
    };
    if (this.relatedEntityName === 'contact') {
      params['received_by_contact_id'] = this.relatedEntityId;
      params['from_system'] = 0;
      if (this.otherContactRelatedMessages) {
        params['from_system'] = 1;
        params['avoid_related_entity_type'] = this.relatedEntityType;
      }
    } else if (this.relatedEntityName === 'activity') {
      params['from_enrollments_related_with_activity_id'] = this.filters.find(item => {
        return item?.filterField === 'from_enrollments_related_with_activity_id';
      })?.value;
    } else if (this.relatedEntityName === 'activity_group') {
      params['from_enrollments_related_with_activity_group_id'] = this.filters.find(item => {
        return item?.filterField === 'from_enrollments_related_with_activity_group_id';
      })?.value;
    } else {
      params['related_entity_type'] = this.relatedEntityType;
      params['related_entity_id'] = this.relatedEntityId;
    }

    return params;
  }

  clickOnShowMessage(message) {
    this.messageTitle = message.title;
    this.messageBody = message.message;
    this.$bvModal.show(this.showMessageModalId);
  }

  onCloseShowMessageModal() {
    this.$bvModal.hide(this.showMessageModalId);
    this.messageTitle = null;
    this.messageBody = null;
  }

  extendedActionsAfterSendMessage() {
    this.getMessagesFromRelatedEntity();
  }

  // Watchers
  @Watch('currentPage')
  onCurrentPageChange() {
    this.getMessagesFromRelatedEntity();
  }
}
